/* =========================================================================
   Register-prompt scheduling — pure logic, unit-tested (mirrors dyk.ts).
   After a guest has answered CUMULATIVE 20 questions across all rounds, offer a
   one-time nudge to create an account. Uses >= so a collision with a mid-round
   break (which returns early from advanceAfterReveal) simply defers the prompt
   to the next reveal instead of losing it — the same deferral trick as dyk.ts.
   Authenticated players never see it; it fires at most once per game.

   NOTE: the register prompt (cumulative 20) is checked BEFORE the "Did You
   Know?" fact (cumulative 22) in advanceAfterReveal, and each still fires at its
   own threshold — they never share a reveal.
   ========================================================================= */
export const REGISTER_PROMPT_THRESHOLD = 20;

export function registerPromptShouldFire(
  cumulativeAnswered: number,
  alreadyShown: boolean,
  authenticated: boolean,
): boolean {
  if (authenticated) return false;
  if (alreadyShown) return false;
  return cumulativeAnswered >= REGISTER_PROMPT_THRESHOLD;
}
